import { OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { Directive, ElementRef } from "@angular/core";
import { MatSpinner } from "@angular/material/progress-spinner";
import { from, isObservable, Observable } from "rxjs";
import { finalize, first } from "rxjs/operators";
import { ElementLoaderOverlay } from "./element-loader-overlay";

@Directive({
  selector: "[lhpeElementLoader]",
  exportAs: "elementloader",
})
export class ElementLoaderDirective {
  private obsQueueCount = 0;
  private elementLoaderOverlayRef: OverlayRef;
  constructor(
    elementRef: ElementRef,
    private elementLoaderOverlay: ElementLoaderOverlay,
  ) {
    this.elementLoaderOverlayRef =
      this.elementLoaderOverlay.createWithDefaultConfig(
        elementRef.nativeElement,
      );
  }

  private increaseObsQueue() {
    this.obsQueueCount++;
    //Only attach if its the first obs/promise to await
    if (this.obsQueueCount === 1) {
      this.elementLoaderOverlayRef.attach(new ComponentPortal(MatSpinner));
    }
  }

  private decreaseObsQueue() {
    this.obsQueueCount--;
    // Only detach once last obs/promise is completed
    if (this.obsQueueCount === 0) {
      this.elementLoaderOverlayRef.detach();
    }
  }

  waitForEvent(event: Observable<any> | Promise<any>) {
    this.increaseObsQueue();
    //TODO: We're assuming we only want the first value from the api, revisit this to account for streams

    if (isObservable(event)) {
      return event.pipe(
        first(),
        finalize(() => this.decreaseObsQueue()),
      );
    }
    //assume its a promise if it has a then function
    else if (!!event.then) {
      return from(event).pipe(
        first(),
        finalize(() => this.decreaseObsQueue()),
      );
    }

    return from(new Promise((resolve) => resolve(null))).pipe(
      first(),
      finalize(() => this.decreaseObsQueue()),
    );
  }
}
